import { useQuery } from 'hooks/useCustomQuery';
import getCompany from 'API/Company/getCompany';

const useGetCompanyByID = (companyID, onSuccess, resetToMainTable, enabled) => {
    return useQuery({
        queryKey: ['company', companyID],
        queryFn: async () => {
            return getCompany(companyID);
        },
        enabled: enabled && Boolean(companyID),
        onSuccess: (data) => {
            if (onSuccess) {
                onSuccess(data);
            }
        },
        onError: (error) => {
            console.error('Error fetching company:', error);
            if (resetToMainTable) {
                resetToMainTable();
            }
        },
        staleTime: 0,
    });
};

export default useGetCompanyByID;
